export type GrowthPublishPlanStatus = 'Draft' | 'Suggested' | 'Approved' | 'Rejected' | 'Executed';

const PUBLISH_PLAN_STATUS_BY_NUMBER: Record<number, GrowthPublishPlanStatus> = {
  0: 'Draft',
  1: 'Suggested',
  2: 'Approved',
  3: 'Rejected',
  4: 'Executed'
};

const PUBLISH_PLAN_STATUS_VALUES = new Set<string>(Object.values(PUBLISH_PLAN_STATUS_BY_NUMBER));

export function normalizePublishPlanStatus(value: unknown): GrowthPublishPlanStatus {
  if (typeof value === 'number' && value in PUBLISH_PLAN_STATUS_BY_NUMBER) {
    return PUBLISH_PLAN_STATUS_BY_NUMBER[value];
  }

  if (typeof value === 'string') {
    if (/^\d+$/.test(value)) {
      const parsed = Number(value);
      if (parsed in PUBLISH_PLAN_STATUS_BY_NUMBER) {
        return PUBLISH_PLAN_STATUS_BY_NUMBER[parsed];
      }
    }

    if (PUBLISH_PLAN_STATUS_VALUES.has(value)) {
      return value as GrowthPublishPlanStatus;
    }
  }

  return 'Draft';
}

export function isPublishPlanApproved(status: unknown): boolean {
  const normalized = normalizePublishPlanStatus(status);
  return normalized === 'Approved' || normalized === 'Executed';
}

export function canExecutePublishPlan(status: unknown): boolean {
  return normalizePublishPlanStatus(status) === 'Approved';
}

export function isPublishPlanTerminal(status: unknown): boolean {
  const normalized = normalizePublishPlanStatus(status);
  return normalized === 'Executed' || normalized === 'Rejected';
}

export const PUBLISH_PLAN_STATUS_I18N_KEYS: Record<GrowthPublishPlanStatus, string> = {
  Draft: 'growth.articlePublishing.planStatus.draft',
  Suggested: 'growth.articlePublishing.planStatus.suggested',
  Approved: 'growth.articlePublishing.planStatus.approved',
  Rejected: 'growth.articlePublishing.planStatus.rejected',
  Executed: 'growth.articlePublishing.planStatus.executed'
};
